import { css } from '@emotion/react';
import { Black, Gray, Main, White } from '@constants/color';

export const buttonContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  rowGap: 40,
  width: '512px'
});

export const title = css({
  fontSize: 32,
  lineHeight: '41.6px',
  fontWeight: 700,
  color: White.White10,
  paddingBottom: 40
});

export const focusedKakaoButton = css({
  backgroundColor: Main.kakao,
  color: Gray.Gray100
});
export const focusedKakaoButtonIcon = css({
  fill: Black.Black10
});
